export function isDefined(x: any) {
  return typeof x !== 'undefined' && x !== null;
}
